import ThreadPortalItem from "../../common/ThreadPortalItem";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import LoadingContent from "../../common/LoadingContent";
import LoadingNoMoreContent from "../../common/LoadingNoMoreContent";

const ThreadListPromote = ({ title = null, threads, hasMoreThreads = null, loadMoreThreads = null, threadsLoading = null, currentPage = null, pageCount = null, onPageChange = null, loading = false }) => {
	const { t } = useTranslation();

	return (
		<div className="border border-borderColor rounded-lg">
			{title && <h3 className="p-4 text-white border-b border-borderColor">{title}</h3>}

			{threads && threads.length > 0 ? (
				<div className="p-1 md:p-4">
					<div className="grid grid-cols-2 gap-2 lg:grid-cols-5 lg:gap-4">
						{threads.map((thread, index) => (
							<ThreadPortalItem key={index} thread={thread} />
						))}
					</div>

					{hasMoreThreads === true && loadMoreThreads !== null ? (
						<div className="text-center mt-4">
							<button
								onClick={loadMoreThreads}
								className="px-2 py-1 bg-primary text-sm font-semibold text-white rounded transition hover:bg-red-900"
							>
								{threadsLoading ? "Loading..." : "Load More"}
							</button>
						</div>
					) : (
						<>
							{pageCount !== null && pageCount > 1 && onPageChange !== null && currentPage !== null && (
								<div className="mt-4">
									<ReactPaginate
										previousLabel={
											<span>
										<FontAwesomeIcon icon={faChevronLeft} className="text-xs" /> Trang trước
									</span>
										}
										nextLabel={
											<span>
										Trang sau <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
									</span>
										}
										breakLabel={"..."}
										breakClassName={"break-me"}
										pageCount={pageCount}
										marginPagesDisplayed={2}
										pageRangeDisplayed={5}
										onPageChange={onPageChange}
										containerClassName={"pagination"}
										subContainerClassName={"pages pagination"}
										activeClassName={"active"}
										initialPage={currentPage - 1}
									/>
								</div>
							)}
						</>
					)}
				</div>
			) : (
				<div className="p-1 text-white text-center md:p-4">
					{loading || currentPage > 1 || threadsLoading ? (
						<LoadingContent />
					) : (
						<LoadingNoMoreContent />
					)}
				</div>
			)}
		</div>
	);
};

export default ThreadListPromote;
